var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ActionModel, Dictionary, Inject } from '../Application';
import { Constants, Events, RequestType } from '../Contract';
import { RequestConfig } from '../Server';
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
import { Commands } from './Command';
import { WindowType } from './Command/WindowType';
var ViewManager = (function () {
    function ViewManager(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject || Inject.Instance;
        this.viewResolver = this.inject.resolve(Constants.ViewResolver);
        this.views = new Dictionary();
        this.pendingViews = new Dictionary();
        this.commands = new Dictionary();
        this.action = this.inject.resolve(Constants.Action);
        this.modalFactory = this.inject.resolve(Constants.ModalFactory);
        this.event = this.inject.resolve(Constants.EventAggregator);
        this.initializeCommand();
    }
    ViewManager.prototype.createView = function (model, items, views) {
        var _this = this;
        if (items && views) {
            this.viewResolver.resolve(model, function (view) {
                views.push(view);
                _this.viewCreated(view);
                if (views.length === items.length) {
                    items.forEach(function (c) { return views.filter(function (d) { return d.model.UniqueID === c; }).forEach(function (v) { return _this.viewLoad(v, views); }); });
                }
            });
        }
        else {
            this.viewResolver.resolve(model, function (view) { return _this.viewCreated(view); });
        }
    };
    ViewManager.prototype.viewLoad = function (view, views) {
        if (view.isPendingLoad(view, views)) {
            this.pendingViews.add(view.model.UniqueID, view);
        }
        else {
            view.load();
        }
    };
    ViewManager.prototype.removePendingView = function (viewId) {
        var view = this.pendingViews.value(viewId);
        if (view) {
            this.pendingViews.remove(viewId);
        }
    };
    ViewManager.prototype.getPendingViews = function () {
        return this.pendingViews;
    };
    ViewManager.prototype.viewCreated = function (view) {
        this.views.add(view.model.UniqueID, view);
    };
    ViewManager.prototype.deleteView = function (viewId) {
        var view = this.views.value(viewId);
        if (view) {
            view.close();
            this.views.remove(viewId);
        }
    };
    ViewManager.prototype.setTopView = function (viewId) {
        var view = this.views.value(viewId);
        if (view) {
            view.focus();
        }
    };
    ViewManager.prototype.getView = function (model) {
        var uniqueId = model.UniqueID;
        return this.views.value(uniqueId);
    };
    ViewManager.prototype.removeViews = function (data) {
        if (data.RemovedViews) {
            for (var _i = 0, _a = data.RemovedViews; _i < _a.length; _i++) {
                var removed = _a[_i];
                this.deleteView(removed);
            }
        }
    };
    ViewManager.prototype.execute = function (command) {
        if (this.commands.value(command.name)) {
            this.commands.value(command.name)(command);
        }
    };
    ViewManager.prototype.hasCommand = function (command) {
        return command && this.commands && this.commands.containsKey(command.name);
    };
    ViewManager.prototype.registerCommand = function (name, fn) {
        this.commands.add(name, fn);
    };
    ViewManager.prototype.registerModal = function (modal) {
        this.modalFactory.register(modal);
    };
    ViewManager.prototype.init = function (views, models) {
        this.models = models;
        this.loadFirstViews(views);
    };
    ViewManager.prototype.loadFirstViews = function (views) {
        if (views && views.LoadedViews) {
            var orderViews = [];
            for (var _i = 0, _a = views.LoadedViews; _i < _a.length; _i++) {
                var current = _a[_i];
                var model = this.models.getModel(current.UniqueID);
                if (this.isModalView(current.UniqueID, views.ModalViews)) {
                    model.IsModalView = true;
                }
                this.createView(model, views.LoadedViews.map(function (c) { return c.UniqueID; }), orderViews);
            }
        }
    };
    ViewManager.prototype.loadDeltas = function (viewDeltas) {
        this.removeViews(viewDeltas);
        this.loadNewViews(viewDeltas.NewViews, viewDeltas.ModalViews);
        this.setFocus(viewDeltas.CurrentFocusedControl);
        this.setTopView(viewDeltas.NewTopView);
    };
    ViewManager.prototype.createViews = function (viewIds) {
        throw new Error('WebMap 5 function not implemented in WebMap 4');
    };
    ViewManager.prototype.updateViews = function (viewIds) {
        throw new Error('WebMap 5 function not implemented in WebMap 4');
    };
    ViewManager.prototype.startEditControlHandler = function (command) {
        var control = this.models.getModel(command.myControlId);
        if (control) {
            control.startEditing = true;
        }
    };
    ViewManager.prototype.initializeCommand = function () {
        var _this = this;
        this.registerCommand(Commands.CloseCommand, function (command) { return _this.closeHandler(command); });
        this.registerCommand(Commands.ClientCloseCommand, function (command) { return _this.clientCloseHandler(command); });
        this.registerCommand(Commands.SendCommand, function (command) { return _this.sendHandler(command); });
        this.registerCommand(Commands.InputBoxActionCommand, function (command) { return _this.inputBoxActionHandler(command); });
        this.registerCommand(Commands.ModalCommand, function (command) { return _this.modalHandler(command); });
        this.registerCommand(Commands.ModalActionCommand, function (command) { return _this.modalActionHandler(command); });
        this.registerCommand(Commands.ModalActionButtonCommand, function (command) { return _this.modalActionButtonHandler(command); });
        this.registerCommand(Commands.KeyPressCommand, function (command) { return _this.keyPressHandler(command); });
        this.registerCommand(Commands.PrintActionCommand, function (command) { return _this.printActionHandler(command); });
        this.registerCommand(Commands.MessageBox, function (command) { return _this.messageBoxHandler(command); });
        this.registerCommand(Commands.MsgBox, function (command) { return _this.msgBoxHandler(command); });
        this.registerCommand(Commands.OpenView, function (command) { return _this.openViewHandler(command); });
        this.registerCommand(Commands.CloseView, function (command) { return _this.closeViewHandler(command); });
        this.registerCommand(Commands.InputBox, function (command) { return _this.inputBoxHandler(command); });
        this.registerCommand(Commands.ChangeFocusControlCommand, function (command) { return _this.changefocusControlHandler(command); });
        this.registerCommand(Commands.StartEditCommand, function (command) { return _this.startEditControlHandler(command); });
        this.registerCommand(Commands.ChangeMenuCommand, function (command) { return _this.changeMenuHandler(command); });
        this.registerCommand(Commands.ChangeMenuStateCommand, function (command) { return _this.changeMenuStateHandler(command); });
        this.registerCommand(Commands.ChangeStatusCommand, function (command) { return _this.changeStatusHandler(command); });
        this.registerCommand(Commands.FileExplorer, function (command) { return _this.fileExplorerHandler(command); });
        this.registerCommand(Commands.FileExplorerInput, function (command) { return _this.fileExplorerHandler(command); });
        this.registerCommand(Commands.RefreshApplicationMenu, function (command) {
            return _this.refreshApplicationMenuHandler(command);
        });
        this.registerCommand(Commands.QuitCurrentApplication, function (command) { return _this.quitCurrentApplication(command); });
        this.registerCommand(Commands.PrintScreenCommand, function (command) { return _this.printScreenHandler(command); });
        this.registerCommand(Commands.ContextMenuCommand, function (command) { return _this.contextMenuHandler(command); });
        this.registerCommand(Commands.DisposeWindowCommand, function (command) { return _this.diposeWindowHandler(command); });
        this.registerCommand(Commands.SetTextToDataManagerCommand, function (command) {
            return _this.setTextToDataManagerHandler(command);
        });
        this.registerCommand(Commands.CloseWindowByTimerCommand, function (command) { return _this.closeWindowByTimerHandler(command); });
        this.registerCommand(Commands.ServerVersionCommand, function (command) { return _this.registerVersion(command); });
        this.registerCommand(Commands.ArrangeWindowCommand, function (command) { return _this.arrangeWindowHandler(command); });
        this.registerCommand(Commands.PopMenuCommand, function (command) { return _this.popMenuHandler(command); });
        this.registerCommand(Commands.OpenExternalLinkCommand, function (command) { return _this.openExternalLinkHandler(command); });
        if (this.onRegisterCommand) {
            this.onRegisterCommand();
        }
    };
    ViewManager.prototype.diposeWindowHandler = function (disposeWindow) {
        var modelResolver = this.inject.resolve(Constants.ModelResolver);
        modelResolver.resolveRemoved([disposeWindow.windowId]);
        this.event.publish('disposeView', disposeWindow.windowId);
    };
    ViewManager.prototype.changeMenuStateHandler = function (command) {
        var parent = this.models.getModel(command.parentWindow);
        var toolBarVisible = command.toolBarVisible;
        parent = parent.ParentWindow ? this.models.getModel(parent.ParentWindow) : parent;
        if (parent.Menu) {
            parent.toolbarVisibleInternal = toolBarVisible;
        }
    };
    ViewManager.prototype.changeMenuHandler = function (command) {
        var parent = this.models.getModel(command.parentWindow);
        var menu = (parent && !parent.Menu) ? parent.MenuID : this.models.getModel(command.newMenuId);
        var toolbarframetitle = command.toolBarFrameTitle;
        var toolbarsheettitle = command.toolBarSheetTitle;
        if (parent && menu) {
            menu.ToolbarVisible = parent.ToolbarVisible;
            menu.ToolBarFrameTitle = toolbarframetitle;
            menu.ToolBarSheetTitle = toolbarsheettitle;
            if (parent.WindowType === WindowType.mdi ||
                parent.WindowType === WindowType.mdihelp ||
                !parent.ParentWindow) {
                parent.Menu = menu;
            }
            else {
                menu.isChild = true;
                parent.ParentWindow.Menu = menu;
            }
            menu.Refresh = true;
        }
    };
    ViewManager.prototype.setTextToDataManagerHandler = function (command) {
        this.event.publish(Events.SetDMText, command);
    };
    ViewManager.prototype.arrangeWindowHandler = function (command) {
        this.event.publish(Events.ArrangeWindow, command);
    };
    ViewManager.prototype.fileExplorerHandler = function (command) {
        var modal = this.modalFactory.create(command.ModalName);
        modal.show(command);
    };
    ViewManager.prototype.changeStatusHandler = function (command) {
        var menu = this.models.getModel(command.MDIId);
        if (menu) {
            menu.MicroHelp = command.message;
        }
    };
    ViewManager.prototype.setFocus = function (control) {
        if (control) {
            var model = this.models.search(control);
            if (model) {
                model.applyMethod('focus');
            }
        }
    };
    ViewManager.prototype.loadNewViews = function (newViews, modalViews) {
        if (newViews) {
            var orderViews = [];
            for (var _i = 0, newViews_1 = newViews; _i < newViews_1.length; _i++) {
                var item = newViews_1[_i];
                var model = this.models.getModel(item);
                if (this.isModalView(item, modalViews)) {
                    model.IsModalView = true;
                }
                this.createView(model, newViews, orderViews);
            }
        }
    };
    ViewManager.prototype.isModalView = function (viewId, modalViews) {
        return (modalViews && modalViews.indexOf(viewId) > -1);
    };
    ViewManager.prototype.inputBoxHandler = function (command) {
        var modal = this.modalFactory.create(command.name);
        modal.show(command);
    };
    ViewManager.prototype.messageBoxHandler = function (command) {
        var modal = this.modalFactory.create('msg');
        modal.show(command);
    };
    ViewManager.prototype.msgBoxHandler = function (command) {
        var modal = this.modalFactory.create(command.name);
        modal.show(command);
    };
    ViewManager.prototype.openViewHandler = function (command) {
        var model = this.models.getModel(command.UniqueID);
        this.createView(model);
    };
    ViewManager.prototype.closeViewHandler = function (command) {
        this.deleteView(command.UniqueID);
        this.models.deleteCascade(command.UniqueID);
    };
    ViewManager.prototype.closeHandler = function (command) {
        this.action.send(new ActionModel(command.sender.name, command.action, command.sender.model));
    };
    ViewManager.prototype.clientCloseHandler = function (command) {
        this.action.send(new ActionModel(command.controller, command.action, undefined, command.args));
    };
    ViewManager.prototype.sendHandler = function (command) {
        this.action.send(new ActionModel(command.sender.name, command.action, command.sender.model, command.args, command.callback, null, command.highPriority));
    };
    ViewManager.prototype.modalHandler = function (command) {
        var modal = this.modalFactory.create(command.modalName());
        if (modal) {
            modal.show(command.parameters());
        }
    };
    ViewManager.prototype.printActionHandler = function (command) {
        this.sendPrintActionHandler(command);
    };
    ViewManager.prototype.sendPrintActionHandler = function (command) {
        this.action.send(new ActionModel(command.controller, command.action, null, {
            dialogResult: command.dialogResult,
            parameters: command.args
        }, undefined, new RequestConfig(RequestType.RawRequest)));
    };
    ViewManager.prototype.modalActionHandler = function (command) {
        this.sendActionHandler(command, 'ResumeOperation');
    };
    ViewManager.prototype.modalActionButtonHandler = function (command) {
        this.sendActionButtonHandler(command, 'ResumeOperation');
    };
    ViewManager.prototype.inputBoxActionHandler = function (command) {
        this.sendActionHandler(command, 'WebMapViewManager');
    };
    ViewManager.prototype.changefocusControlHandler = function (command) {
        var control = this.models.getModel(command.myControlId);
        if (this.lastFocusedControl) {
            this.lastFocusedControl.isFocused = false;
        }
        if (control) {
            this.lastFocusedControl = control;
            control.isFocused = true;
        }
    };
    ViewManager.prototype.refreshApplicationMenuHandler = function (command) {
        var menu = this.models.getModel(command.menuId);
        if (menu) {
            menu.Refresh = true;
        }
    };
    ViewManager.prototype.sendActionHandler = function (command, controller) {
        this.action.send(new ActionModel(controller, 'ResumePendingOperation', null, {
            dialogResult: command.dialogResult,
            requestedInput: command.requestedInput
        }, undefined, new RequestConfig(RequestType.RawRequest)));
    };
    ViewManager.prototype.sendActionButtonHandler = function (command, controller) {
        this.action.send(new ActionModel(controller, 'ResumePendingOperation', null, {
            buttons: command.buttons
        }, undefined, new RequestConfig(RequestType.RawRequest)));
    };
    ViewManager.prototype.keyPressHandler = function (command) {
        this.action.send(new ActionModel(command.sender.name, command.action, command.sender.model, new Array({ keyCode: command.key })));
    };
    ViewManager.prototype.quitCurrentApplication = function (command) {
        this.event.publish(Events.ApplicationRestart);
    };
    ViewManager.prototype.printScreenHandler = function (command) {
        window.print();
    };
    ViewManager.prototype.contextMenuHandler = function (command) {
        var subMenu = this.models.getModel(command.subMenu);
        var window = this.models.getModel(command.window);
        if (subMenu && window) {
            subMenu.Refresh = true;
            window.ContextMenu = subMenu;
        }
    };
    ViewManager.prototype.openExternalLinkHandler = function (command) {
        window.open(command.path, '_blank');
    };
    ViewManager.prototype.closeWindowByTimerHandler = function (command) {
        var model = this.models.getModel(command.windowId);
        model.closeByTime = command.miliSeconds;
    };
    ViewManager.prototype.popMenuHandler = function (command) {
        var model = this.models.getModel(command.windowId);
        if (model) {
            model.popMenu = command.subMenuId;
        }
    };
    ViewManager.prototype.registerVersion = function (command) {
        var version = window.app.version;
        version.dcpVersion = command.dcpVersion;
        version.coreVersion = command.coreVersion;
    };
    ViewManager = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [Object])
    ], ViewManager);
    return ViewManager;
}());
export { ViewManager };
